const discounts = {
	add_button: "Rabatt erstellen",
	alerts: {
		discount_added: "Rabatt <strong>{{name}}</strong> erfolgreich hinzugefügt!",
		discount_edited: "Rabatt <strong>{{name}}</strong> erfolgreich bearbeitet!",
	},
	calculate_dialog: {
		discount: "Rabatt",
		margin: "Marge",
		name: "Produktname",
		price_purchase: "Einkaufspreis",
		price_recommended: "Empfohlener Preis",
		price_result: "Preis",
	},
	create: {
		title: "Rabatt erstellen",
	},
	delete_dialog: {
		description: "Möchten Sie <strong>{{discount_label}}</strong> wirklich löschen?",
		title: "Rabatt löschen",
	},
	edit: {
		title: "Rabatt bearbeiten",
	},
	form: {
		active: "Aktiv",
		all_debtors: "Jeder",
		all_products: "Alle Produkte",
		amount: "Fester Rabattbetrag",
		and: "Und",
		applies_to: "Gültig für",
		debtor: "Schuldner",
		debtor_group: "Schuldnergruppe",
		debtor_type: "Zielgruppe",
		discount_type: "Rabatttyp",
		duration_undetermined: "Unbestimmt",
		if: "Wenn",
		information: "Information",
		label: "Rabattbezeichnung",
		percentage: "Prozentsatz",
		product: "Produkt",
		product_domain: "Domainname (Produkt)",
		product_group: "Produktgruppe",
		product_group_apply_to: {
			each_product: "Jedes Produkt in der Produktgruppe",
			product_group: "Auf den Gesamtpreis der Produktgruppe",
			title: "Rabatt anwenden auf",
		},
		single_debtor: "Einzelner Schuldner",
		single_product: "Einzelnes Produkt",
		then: "Dann",
		till: "Bis",
	},
	overview: "Rabattübersicht",
	status: {
		create: {
			success: "Rabatt erfolgreich hinzugefügt!",
			unknown:
				"Rabatt kann momentan nicht hinzugefügt werden. Bitte versuchen Sie es später erneut.",
		},
		delete: {
			success: "Rabatt erfolgreich gelöscht!",
			unknown: "Rabatt kann momentan nicht gelöscht werden. Bitte versuchen Sie es später erneut.",
		},
		edit: {
			success: "Rabatt erfolgreich bearbeitet!",
			unknown:
				"Rabatt kann momentan nicht bearbeitet werden. Bitte versuchen Sie es später erneut.",
		},
	},
	table: {
		debtor_type: "Zielgruppe",
		details: "Details",
		id: "ID",
		label: "Bezeichnung",
		product_type: "Gültig für",
		table_items: {
			all_products: "Alle Produkte",
			everyone: "Alle",
		},
		type: "Rabatttyp",
	},
	title: "Rabatte",
};

export default discounts;
